import TSwitch from './switch.vue'

TSwitch.install = Vue => {
  Vue.component(TSwitch.name, TSwitch)
}

export default TSwitch



// WEBPACK FOOTER //
// ./src/module/switch/index.js